import { jsxs, jsx } from "react/jsx-runtime";
import { cva } from "../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Chip.module.scss.js";
const chipVariants = cva(["leading-normal inline-flex items-center rounded-full font-medium whitespace-nowrap"], {
  variants: {
    color: {
      primary: [],
      secondary: [],
      success: [],
      danger: [],
      warning: [],
      inherit: []
    },
    variant: {
      default: [],
      shaded: [styles["shaded-elevation"]],
      outlined: []
    },
    size: {
      sm: ["text-[11px] px-[6px] h-6"],
      normal: ["text-xs px-2 h-7"],
      lg: ["text-sm px-[10px] h-8"]
    }
  },
  compoundVariants: [
    // Default
    {
      color: "primary",
      variant: "default",
      className: ["bg-primary", "text-primary-contrast"]
    },
    {
      color: "secondary",
      variant: "default",
      className: ["bg-secondary", "text-secondary-contrast"]
    },
    {
      color: "success",
      variant: "default",
      className: ["bg-success", "text-success-contrast"]
    },
    {
      color: "danger",
      variant: "default",
      className: ["bg-danger", "text-danger-contrast"]
    },
    {
      color: "warning",
      variant: "default",
      className: ["bg-warning", "text-warning-contrast"]
    },
    {
      color: "inherit",
      variant: "default",
      className: ["bg-inherit"]
    },
    // Shaded
    {
      color: "primary",
      variant: "shaded",
      className: ["bg-primary/10", "text-primary"]
    },
    {
      color: "secondary",
      variant: "shaded",
      className: ["bg-secondary/10", "text-secondary"]
    },
    {
      color: "success",
      variant: "shaded",
      className: ["bg-success/10", "text-success"]
    },
    {
      color: "danger",
      variant: "shaded",
      className: ["bg-danger/10", "text-danger"]
    },
    {
      color: "warning",
      variant: "shaded",
      className: ["bg-warning/10", "text-warning"]
    },
    // Outline
    {
      color: "primary",
      variant: "outlined",
      className: ["border border-primary", "text-primary"]
    },
    {
      color: "secondary",
      variant: "outlined",
      className: ["border border-secondary", "text-secondary"]
    },
    {
      color: "success",
      variant: "outlined",
      className: ["border border-success", "text-success"]
    },
    {
      color: "danger",
      variant: "outlined",
      className: ["border border-danger", "text-danger"]
    },
    {
      color: "warning",
      variant: "outlined",
      className: ["border border-warning", "text-warning"]
    },
    {
      color: "inherit",
      variant: "outlined",
      className: ["border border-inherit", "text-inherit"]
    }
  ],
  defaultVariants: {
    color: "primary",
    variant: "default",
    size: "normal"
  }
});
const Chip = forwardRef((props, ref) => {
  const { label, labelClassName, icon, color, variant, size, onDelete, className, ...rest } = props;
  return /* @__PURE__ */ jsxs("div", { ...rest, ref, className: twMerge(chipVariants({ color, variant, size, className })), children: [
    icon,
    /* @__PURE__ */ jsx("span", { className: twMerge("mx-1", labelClassName), children: label }),
    onDelete && /* @__PURE__ */ jsx("button", { type: "button", onClick: onDelete, children: /* @__PURE__ */ jsx(
      "svg",
      {
        width: "1.2em",
        height: "1.2em",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.782 4.032a.575.575 0 10-.813-.814L7.5 6.687 4.032 3.218a.575.575 0 00-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 00.814.814L7.5 8.313l3.469 3.469a.575.575 0 00.813-.814L8.313 7.5l3.469-3.468z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          }
        )
      }
    ) })
  ] });
});
export {
  Chip as default
};
//# sourceMappingURL=Chip.js.map
